import { render } from "./mapTable.vue?vue&type=template&id=2d2af836&scoped=true&ts=true"
import script from "./mapTable.vue?vue&type=script&lang=ts"
export * from "./mapTable.vue?vue&type=script&lang=ts"

import "./mapTable.vue?vue&type=style&index=0&id=2d2af836&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2af836"]])

export default __exports__